(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-template"]) return;
  try {
    
    function CopyMe(TextToCopy) {
        var TempText = document.createElement("input");
        TempText.value = TextToCopy;
        document.body.appendChild(TempText);
        TempText.select();

        document.execCommand("copy");
        document.body.removeChild(TempText);

        console.log("Copied the text: " + TempText.value);
    }
	$(document).on('click', '.social-media__item--copy', function(e) {
		e.preventDefault();
		CopyMe(window.location.href);

		const $toolTipText = $(this).find('.tooltiptext');
		
		$toolTipText.fadeIn(function() {
			setTimeout(function() {
				$toolTipText.fadeOut();
			}, 150);
		});
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-filter-by"]) return;
  try {
    
	$(document).on('click', '.filter-by-region-tabs > div', function(e) {
      e.preventDefault();
      if($(this).hasClass('active')) return false;
	  const $cont = $('.filter-by-region-content');
      const target = $(this).attr('data-tag');
	  const $target =  $cont.find('.blog-latest-grid[data-tag="' + target + '"]');

      $('.filter-by-region-tabs > div.active').removeClass('active');
      $(this).addClass('active');
      
      $cont.find('.blog-latest-grid').slideUp();
      $target.css('display', 'flex');

	  $('.view-more-articles').toggle($target.find('> div').length > 6);
    });
	
	$(document).on('click', '.view-more-articles', function() {
		const isShowingAllArticles = $('.blog-filter-by-grid').hasClass('show-all-grid');
		let textLabel = $(this).attr('data-view-more');

		if(!isShowingAllArticles) {
			$('.blog-filter-by-grid').addClass('show-all-grid');
			textLabel = $(this).attr('data-view-less');
		} else {
			$('.blog-filter-by-grid').removeClass('show-all-grid');
		}
		$(this).text(textLabel);

		if(isShowingAllArticles) {
			$('body, html').animate({
				scrollTop: $('.blog-filter-by-grid').position().top
			}, 1000);
		}
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["braces-category-faq"]) return;
  try {
    
	$(document).on('click', '.faq-module .faq-item__header', function(e) {
      e.preventDefault(); 
      const $parentEl = $(this).parents('.faq-item');
	  $parentEl.toggleClass('active');

      $parentEl.find('.faq-item__body').slideToggle();
    });
	$(document).on('click', '.faq-module .load-more-faq', function(e) {
    	e.preventDefault(); 

		$(this).slideToggle();
		$('.faq-item.load-more-hidden').slideToggle();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canes-category-faq"]) return;
  try {
    
	$(document).on('click', '.faq-module .faq-item__header', function(e) {
      e.preventDefault(); 
      const $parentEl = $(this).parents('.faq-item');
	  $parentEl.toggleClass('active');

      $parentEl.find('.faq-item__body').slideToggle();
    });
	$(document).on('click', '.faq-module .load-more-faq', function(e) {
      e.preventDefault(); 

		$(this).slideToggle();
		$('.faq-item.load-more-hidden').slideToggle();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  if (!window.jQuery) return;

  var $slider = jQuery(".slick-collection-list");

  if (!$slider.length) return;

  /* Destroy theme initialization */
  if ($slider.hasClass("slick-initialized")) {
    $slider.slick("unslick");
  }

  /* Re-init with correct settings */
  $slider.slick({
    rows: 1,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: false,
    swipe: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2
        }
      }
    ]
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compression-category-faq"]) return;
  try {
    
	$(document).on('click', '.faq-module .faq-item__header', function(e) {
      e.preventDefault(); 
      const $parentEl = $(this).parents('.faq-item');
	  $parentEl.toggleClass('active');

      $parentEl.find('.faq-item__body').slideToggle();
    });
	$(document).on('click', '.faq-module .load-more-faq', function(e) {
      e.preventDefault(); 

		$(this).slideToggle();
		$('.faq-item.load-more-hidden').slideToggle();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cpap-category-faq"]) return;
  try {
    
	$(document).on('click', '.faq-module .faq-item__header', function(e) {
      e.preventDefault(); 
      const $parentEl = $(this).parents('.faq-item');
	  $parentEl.toggleClass('active');

      $parentEl.find('.faq-item__body').slideToggle();
    });
	$(document).on('click', '.faq-module .load-more-faq', function(e) {
      e.preventDefault(); 

		$(this).slideToggle();
		$('.faq-item.load-more-hidden').slideToggle();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cpap-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const heroButton = document.querySelector('.cpap-hero__button');
    if (heroButton) {
      heroButton.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-category-faq"]) return;
  try {
    
	$(document).on('click', '.faq-module .faq-item__header', function(e) {
      e.preventDefault(); 
      const $parentEl = $(this).parents('.faq-item');
	  $parentEl.toggleClass('active');

      $parentEl.find('.faq-item__body').slideToggle();
    });
	$(document).on('click', '.faq-module .load-more-faq', function(e) {
      e.preventDefault(); 

		$(this).slideToggle();
		$('.faq-item.load-more-hidden').slideToggle();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-map"] && !Shopify.designMode) return;
  try {
    
	window.map = null;
	window.googleMapLoaded = false;
	const googleAPIKey= $("#google-map").attr('data-api-key');
	const BullseySearchAPI = 'https://ws2.bullseyelocations.com/RestSearch.svc/DoSearch2?ClientId=4664&ApiKey=27ab1bab-2901-4156-aec2-bfb51a7ce538&CountryID=2&StartIndex=0&PageSize=50&radius=15&Keyword=wellwise';
	
    // Create the script tag, set the appropriate attributes
    var script = document.createElement('script');
	script.src = 'https://maps.googleapis.com/maps/api/js?key=' + googleAPIKey + '&callback=initMap';
    script.async = true;

    // Attach your callback function to the `window` object
    window.initMap = function() {
		window.geocoder = new google.maps.Geocoder();
		window.map = new google.maps.Map(document.getElementById('google-map'), {
  			center: {
				lat: 43.68141177546197, 
				lng: -79.38203763271723
			},
  			zoom: 11,
			disableDefaultUI: true
		});
    };

    $(window).scroll(function() {
        const $findLocation = $('.find-location-module')
        const top_of_element = $findLocation.offset().top;
        const bottom_of_element = $findLocation.offset().top + $findLocation.outerHeight();
        const bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        const top_of_screen = $(window).scrollTop();

        if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element) && !window.googleMapLoaded) {
            console.log('Google map init');
            window.googleMapLoaded = true;
            document.head.appendChild(script);
        } else {
            //console.log('not in view');
        }
    });

	const addMarkers = function(searchEndpoint, searchKey) {
        $.ajax({
             url: searchEndpoint,
             type: "GET",
             dataType: "json",
             success: function(data) {
             	if(typeof data !== 'undefined') {
					let searchListHtml = '';
					
					if(searchKey) {
						searchListHtml += '<p class="find-location_search-results-label">Stores results for: ' + searchKey + '</p>';
					}
                    data.ResultList.map(function(retailer, index) {
						const isCenter = index == 0;
                        const retailerLatLng = {
                            lat: retailer.Latitude, 
                            lng: retailer.Longitude
                        };
						const retailerName = retailer.Name.replace('WELLWISE ', '');
                        const contentString = `<div class="content marker-content" data-lat="${retailer.Latitude}" data-lng="${retailer.Longitude}">
                          <h1>${retailerName}</h1>
                          <p> Wellwise <br />
                          ${retailer.Address1} <br />
                          ${retailer.City}, ${retailer.State} <br />
                          ${retailer.PostCode} <br />
                          Tel: <a href="tel:${retailer.PhoneNumber}">${retailer.PhoneNumber}</a></p>
                        </div>`;
                        const infowindow = new google.maps.InfoWindow({
                            content: contentString,
                        });
                        const marker = new google.maps.Marker({
                           position: retailerLatLng,
                           title: retailer.Name,
                           icon: "https://cdn.shopify.com/s/files/1/0547/5359/1469/files/map-marker_430x.png?v=1729624956#"
                        });
						
                        searchListHtml += `<div class="find-location_search-item" data-lat="${retailer.Latitude}" data-lng="${retailer.Longitude}">
                            <h1>
                              ${retailer.Name.replace('WELLWISE ', '')}
                            </h1>
                            <p> 
                                Wellwise <br />
                                ${retailer.Address1} <br />
                                ${retailer.City}, ${retailer.State} <br />
                                ${retailer.PostCode} <br />
                                Tel: <a href="tel:${retailer.PhoneNumber}">${retailer.PhoneNumber}</a>
                            </p>
                        </div>`;
                        console.log('retailer:', retailer.Name, retailerLatLng);

                        marker.setMap(window.map);
						marker.addListener("click", function() {
							infowindow.open(window.map, marker);
  						});
						
						if(isCenter) {
							window.map.setCenter(retailerLatLng);
							window.map.setZoom(11);
						}
                    });

					$('.find-location_search-list').html(searchListHtml);
					if(searchListHtml.length > 0) {
						$('.find-location-inner').addClass('find-search-active');
					}
                 }
             }
         });
	}

	$(document).on('click', '.geolocate-btn', function() {
		window.navigator.geolocation.getCurrentPosition(function(info) {
			var latitude = info.coords.latitude;
			var longitude = info.coords.longitude;

			if(longitude != null && latitude != null) {
				$('.address-input').removeClass('err-input');
                let searchEndpoint = BullseySearchAPI + '&longitude=' + longitude + "&latitude=" + latitude;
				addMarkers(searchEndpoint);
			}
		});
	});

	$(document).on('click', '.close-search-ic', function() {
		$('.find-location-inner').removeClass('find-search-active');
	});

	$(document).on('click', '.find-location_search-item', function() {
		const $this = $(this);
		const lat = $this.attr('data-lat');
		const lng = $this.attr('data-lng');

		console.log('lat lng', lat, lng);

		if(lat && lng) {
			window.map.setCenter({
				lat: Number(lat),
				lng: Number(lng)
			});
			window.map.setZoom(15);
		}
	});

	$(document).on('click', '.find-store-cta, .find-location_search-header .search-btn', function() {
		const address = $('.address-input').val();
		let searchEndpoint = '';
		$('.address-input').removeClass('err-input');

		if(address.length <= 2) {
			$('.address-input').addClass('err-input');
			return false;
		}
                              
		geocoder.geocode( { 'address': address}, function(results, status) {
          if (status == 'OK') {
			const latLng = results[0].geometry.location;
            map.setCenter(latLng);
			console.log('data--->', latLng);
			 
			const searchEndpoint = BullseySearchAPI + '&longitude=' + latLng.lng() + "&latitude=" + latLng.lat();
			addMarkers(searchEndpoint, address);
          } else {
			$('.address-input').addClass('err-input');
            //alert('Please enable the Geocoder API in GCM. Status: ' + status);
			//Geocoding API needs to enabled on GCM
          }
        });
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cyber-featured-collection"] && !Shopify.designMode) return;
  try {
    
	const $regionBody = $(".select-region-tab-body");
	const maxCount = parseInt($regionBody.attr('data-max-count'));
	
	$regionBody.on('breakpoint init', function(event, slick) {
		let html = '<ul class="slick-dots custom-dots" style="display: block;">';
	    const dotsLength = Math.ceil(slick.slideCount / slick.options.slidesToShow);
	    const $dots = slick.$dots;

	    if(dotsLength > 1)
	        html += '<li class="not-slick arrow-prev"><span></span></li>';
	    for(var i = 0; i < dotsLength; i++) {
	        html += '<li ' + (i == 0 ? 'class="slick-active"' : '' ) + '><span class="dot"></span></li>';
	    }
	    if(dotsLength > 1)
	        html += '<li class="not-slick arrow-next"><span></span></li>';

	    html += '</ul>';
	    if(dotsLength > 1)
	        $(slick.$list).append(html);
		
		matchHeights('.select-region-tab-body .ptitle', true);
	});

	$(document).on("click", ".select-region-tab-body .product-item__action-button", function (e) {
		e.preventDefault();
		const productVariantID = $(this).attr('data-variant-id');

		const cartData = {
          "bsub-recur": "",
          form_type: "product",
          id: productVariantID,
          "product-template-6704265068717-1": "Extra Small",
          "product-template-6704265068717-2": "10 Count",
          quantity: "1",
          utf8: "✓"
		};

        fetch("/cart/add.js", {
          "headers": {
            "accept": "*/*",
            "content-type": "application/json",
            "sec-fetch-mode": "cors",
            "sec-fetch-site": "same-origin",
            "x-requested-with": "XMLHttpRequest"
          },
		  "body": JSON.stringify(cartData),
          "method": "POST",
          "mode": "cors",
        }).then(res => res.json()).then((res) => {
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                  quantity: 1
              }
          }));
        });
	});

    $(document).on("click", ".select-region-tabs > div", function (e) {
      e.preventDefault();
	
	  if($(this).hasClass('active')) return false;
	  if($regionBody.hasClass('slick-initialized')) {
		$regionBody.slick('unslick');
	  }

      if ($(this).hasClass("active")) return false;
	  let productsHtml = '';

      const target = $(this).text().trim().toLowerCase();
      const collection = $(this).attr("data-collection");
	  $('.featured-collection-headline').addClass("display-none");
	  $("#" + collection + "-header").removeClass("display-none");
      $(".select-region-tabs > div.active").removeClass("active");
      $(this).addClass("active");

      $.ajax({
        url: "/collections/" + collection + "/products.json",
        type: "GET",
      }).done(function (data) {
        let productsHtml = "";
        let productsLength = data.products.length;

        if (productsLength > maxCount) {
          productsLength = maxCount;
        }

        for (var i = 0; i < productsLength; i++) {
          const product = data.products[i];
          const discountPrice = product.variants[0].price;
          const productPrice = product.variants[0].compare_at_price || discountPrice;
          const productLink = "/collections/" + collection + "/products/" + product.handle;
          const addToCartLink = "/cart/add?id=" + product.variants[0].id + "&quantity=1";
		  const productVariantID = product.variants[0].id;
          let discountOffNum = Math.round((1 - (discountPrice / productPrice)) * 100);
          let productImage;
          const isFreeShipping = productPrice > 25;
		  const hasMultipleVariants = product.variants.length > 1;
		  const isInStock = product.variants[0].available;
		  let pcPointLabel = `Get ${calculateBasePco(discountPrice)} base points*`;

		  if(typeof window.PCOPoints[productVariantID] !== 'undefined') {
			const pco = window.PCOPoints[productVariantID];

			if(pco.IsPromoTypeFixed) {
                pcPointLabel = `Get ${window.PCOPoints[productVariantID].PCOAmount} bonus points* and ${calculateBasePco(discountPrice)} base points*`;
            } else {
                pcPointLabel = `Get ${window.PCOPoints[productVariantID].PCOAmount}x the points* and ${calculateBasePco(discountPrice)} base points* when purchasing this participating product`;
            }
		  }

          if (product.images.length > 0 && product.images[0].src != null) {
            productImage = product.images[0].src;
          }
		  if(productImage) {
			productImage = productImage.replace('.png', '_200x.png');
		  }

          if (product) {
            productsHtml += `<div class="collections-product-item ${ productPrice != discountPrice ? "has-discount" : ""}">
                <div>
                    <div class="pc-opt-flag">
                        ${pcPointLabel}
                    </div>
                  ${ isFreeShipping ?
                    `<div class="free-shipping-flag">
                        Free Shipping
                    </div>` : ''
                  }
                    <a href="${productLink}">
                      <div class="img-container"> 
                        <img data-src="${ productImage }" class="lazyload" alt="" /> 
                      </div>

                      <span class="heading ptitle">
                        ${product.title}
                      </span>
                    </a>
                    <div class="ww-product-item__price">
                      <div class="price-container">
                        <span class="visually-hidden"> Sale price </span>
                        <span class="discount-price">
                            ${"$" + discountPrice}
                        </span>
                        <span class="price">
                            ${"$" + productPrice}
                        </span>
                      </div>

                      ${ discountOffNum > 0 ?
                        `<div class="price-off-flag">
                          ${discountOffNum}% Off
                        </div>` : ''
                      }
                    </div>
                    <p class="in-stock-flag">
                        In-stock
                    </p>
                </div>

                <a href="${addToCartLink}" data-variant-id="${productVariantID}" class="product-item__action-button button button--primary">Add to cart</a>
            </div>`;
          }
        }

		$regionBody.html(productsHtml);
		$regionBody.slick({
          rows: target ==  $('.select-region-tabs > div:last-child').text().trim().toLowerCase() ? 2 : 1,
          slidesToScroll: 4,
          slidesToShow: 4,
          dots: false,
          arrows: false,
          infinite: true,
		  swipe: false,
          customPaging: function(slider, i) {
            return '<span class="dot"></span>';
          },
          speed: 300,
          responsive: [
			{
              breakpoint: 1450,
              settings: {
                slidesToScroll: 3,
                slidesToShow: 3
              }
            },
			{
              breakpoint: 1250,
              settings: {
                slidesToScroll: 2,
                slidesToShow: 2
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToScroll: 1,
                slidesToShow: 1,
				rows: 1
              }
            }
          ]
        });
      });
  });

  $(document).ready(function () {
  	$(".select-region-tabs > div:first-child").trigger("click");
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daily-category-faq"]) return;
  try {
    
	$(document).on('click', '.faq-module .faq-item__header', function(e) {
      e.preventDefault(); 
      const $parentEl = $(this).parents('.faq-item');
	  $parentEl.toggleClass('active');

      $parentEl.find('.faq-item__body').slideToggle();
    });
	$(document).on('click', '.faq-module .load-more-faq', function(e) {
      e.preventDefault(); 

		$(this).slideToggle();
		$('.faq-item.load-more-hidden').slideToggle();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electronics-category-faq"]) return;
  try {
    
	$(document).on('click', '.faq-module .faq-item__header', function(e) {
      e.preventDefault(); 
      const $parentEl = $(this).parents('.faq-item');
	  $parentEl.toggleClass('active');

      $parentEl.find('.faq-item__body').slideToggle();
    });
	$(document).on('click', '.faq-module .load-more-faq', function(e) {
      e.preventDefault(); 

		$(this).slideToggle();
		$('.faq-item.load-more-hidden').slideToggle();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
	const $regionBody = $(".select-region-tab-body");
	const maxCount = parseInt($regionBody.attr('data-max-count'));
	
	$regionBody.on('breakpoint init', function(event, slick) {
		let html = '<ul class="slick-dots custom-dots" style="display: block;">';
	    const dotsLength = Math.ceil(slick.slideCount / slick.options.slidesToShow);
	    const $dots = slick.$dots;

	    if(dotsLength > 1)
	        html += '<li class="not-slick arrow-prev"><span></span></li>';
	    for(var i = 0; i < dotsLength; i++) {
	        html += '<li ' + (i == 0 ? 'class="slick-active"' : '' ) + '><span class="dot"></span></li>';
	    }
	    if(dotsLength > 1)
	        html += '<li class="not-slick arrow-next"><span></span></li>';

	    html += '</ul>';
	    if(dotsLength > 1)
	        $(slick.$list).append(html);
		
		matchHeights('.select-region-tab-body .ptitle', true);
	});

	$regionBody.on('swipe', function(event, slick, direction) {
      const devisor = slick.$list.find('.slick-active').length;
      const currentSlide = slick.currentSlide / (devisor - 1);
      const $slickList = slick.$list.parents('.slick-slider');

      $slickList.find('.slick-active').removeClass('slick-active');
      $slickList.find('.slick-dots > li:not(.not-slick)').eq(currentSlide).addClass('slick-active');
    });

	$(document).on("click", ".select-region-tab-body .product-item__action-button", function (e) {
		e.preventDefault();
		const productVariantID = $(this).attr('data-variant-id');

		if($(this).hasClass('multiple-vari')) {
			return window.open($(this).attr('data-href'), '_self');
		}

		const cartData = {
          "bsub-recur": "",
          form_type: "product",
          id: productVariantID,
          "product-template-6704265068717-1": "Extra Small",
          "product-template-6704265068717-2": "10 Count",
          quantity: "1",
          utf8: "✓"
		};

        fetch("/cart/add.js", {
          "headers": {
            "accept": "*/*",
            "content-type": "application/json",
            "sec-fetch-mode": "cors",
            "sec-fetch-site": "same-origin",
            "x-requested-with": "XMLHttpRequest"
          },
		  "body": JSON.stringify(cartData),
          "method": "POST",
          "mode": "cors",
        }).then(res => res.json()).then((res) => {
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                  quantity: 1
              }
          }));
        });
	});

    $(document).on("click", ".select-region-tabs > div", function (e) {
      e.preventDefault();
	  if($(this).hasClass('active')) return false;
	  if($regionBody.hasClass('slick-initialized')) {
		$regionBody.slick('unslick');
	  }

      if ($(this).hasClass("active")) return false;
	  let productsHtml = '';

      const target = $(this).text().trim().toLowerCase();
      const collection = $(this).attr("data-collection");
      $(".select-region-tabs > div.active").removeClass("active");
      $(this).addClass("active");  
 
      $.ajax({
        url: "/collections/" + collection + "/products.json",
        type: "GET",
      }).done(function (data) {
        let productsHtml = "";
        let productsLength = data.products.length;

        if (productsLength > maxCount) {
          productsLength = maxCount;
        }

     
        let hasMultiFlag = data.products.filter(x => x.tags.filter(word=> word.includes("Promo")).length > 0 ? true : false)
        let showStartingPrice = false;
        var isOnSale = false;
        
        for (var i = 0; i < productsLength; i++) { 
          var hidePrice = false;
          
          const product = data.products[i];

        var firstPrice = parseFloat(product.variants[0].price);
          
          for (var p = 1; p < product.variants.length; p++) {
              var variantPrice = parseFloat(product.variants[p].price);
              
              if (variantPrice !== firstPrice) {
                  showStartingPrice = true;
                  break;
              }
          }


          for(var p = 0; p < product.variants.length; p++) {  
            isOnSale = false;
            var variant = product.variants[p];             
            if(parseFloat(variant.price) < parseFloat(variant.compare_at_price)){
              isOnSale = true;
              break;
            }
          }
            
          const discountPrice = product.variants[0].price;
          const compareAtPrice = product.variants[0].compare_at_price > 0 && parseFloat(product.variants[0].compare_at_price) < parseFloat(discountPrice) ? discountPrice : product.variants[0].compare_at_price;
          const productPrice = parseFloat(compareAtPrice) > parseFloat(discountPrice) ? compareAtPrice : discountPrice;
          var priceMinVariants = Math.min(...product.variants.map(v => parseFloat(v.price)));
          
          let productLink = "/collections/" + collection + "/products/" + product.handle;
          const addToCartLink = "/cart/add?id=" + product.variants[0].id + "&quantity=1";
		  const productVariantID = product.variants[0].id;
          let discountOffNum = Math.round((1 - (discountPrice / productPrice)) * 100);
          let productImage;      

          
        if(metaObj[0].name != undefined){ 
          for(let i = 0; i < metaObj[0].name.length; i++){             
            if(product.vendor.toLowerCase()  == metaObj[0].name[i].toLowerCase()  && $("#customer-email").val() == ""){
                  hidePrice = true;
                }              
              }
         }

          let isFreeShipping = false;
        
          if (productPrice != discountPrice) {
              if (discountPrice > 75) {
                  isFreeShipping = true;
              } else {
                  isFreeShipping = false;
              }
          } else if (productPrice > 75) {
              isFreeShipping = true;
          } else {
              isFreeShipping = false;
          }

          const hasMultipleVariants = product.variants.length > 1;

          // Check if at least one item has an available set to true          
          for (let i = 0; i < product.variants.length; i++) {           
              if (product.variants[i].available === true) {
                  hasAnyAvailable = true;
                  break;
              }
          }
          
		  const isInStock = hasAnyAvailable;
		  let pcPointLabel = "";
          var basePointsLabel = `Get ${calculateBasePco(discountPrice)} base points*`
          const multiFlag = product.tags.filter(word=> word.includes("Promo")).length > 0 ? true : false;
          let promoTag = multiFlag ? product.tags.filter(word=> word.includes("Promo"))[0].split('##') : "";
          let promo = multiFlag ? promoTag[0].split(':')[1] : "";
        
          let price_min = product.variants.map(x => x.price).sort((a, b) => a - b)[0];
          let price_max = Math.max(...product.variants.map(x => parseFloat(x.compare_at_price)));

          if(hasMultipleVariants) {
            for(let k = 0; k < product.variants.length; k++) {
              if(product.variants[k].price === price_min)
                price_max = product.variants[k].compare_at_price;
            }
          }
          
          let discountPerc = 0;

          if(price_max !== '0.00')
            discountPerc = Math.round((1 - (price_min / price_max)) * 100);           
              
          if (product.images.length > 0 && product.images[0].src != null) {
            productImage = product.images[0].src;
          }

          var variantFeaturedImage = product.variants.map(x => x).sort(function(a, b) {return a.price - b.price})[0];
		  if(productImage && variantFeaturedImage.featured_image != null) {
			productImage = isOnSale ? variantFeaturedImage.featured_image.src.replace('.png', '_200x.png') : productImage.replace('.png', '_200x.png');
		  } 

          productLink = productLink + "?variant="+ product.variants.map(x => x).sort(function(a, b) {return a.price - b.price})[0].id;     
          
          if (product) {
            productsHtml += `<div class="collections-product-item ${ productPrice != discountPrice ? "has-discount" : ""}" style='height: 600px;' }>
                <div>                   
                  ${ isFreeShipping ?
                    `<div class="free-shipping-flag">
                        Free Shipping
                    </div>` : ''
                  }
                    <a class="collections-product-item__link" href="${productLink}" style="cursor:pointer">
                      <div class="img-container"> 
                        <img data-src="${ productImage }" alt="" width="200" height="200" class="lazyload" /> 
                      </div>
                      


                  
                      <span class="heading ptitle">
                        ${product.title}
                      </span>
                    </a>

                      ${ isOnSale && product.variants.length > 1 ?
                       `<div style="font-family: 'Volte';">${sale_text_label }</div>` : ''
                      } 

                      ${ !hidePrice ?
                     `<div class="ww-product-item__price">                     
                        <div class="price-container">
                          <span class="visually-hidden"> Sale price </span>
                           ${ product.variants.length > 1 && showStartingPrice && !isOnSale ?
                               `<span class="price-starting-label" style="color: #1e2d7d;font-size: 18px;font-family: VolteB; margin-right: 3px;">${starting_from_label}</span>` : ''
                            }
                            
                            ${ isOnSale ?
                              `
                               ${ product.variants.length > 1  ?
                               `<span class="price-starting-label" style="color: #cb333b;font-size: 18px;font-family: VolteB; margin-right: 3px;">${starting_from_label}</span>` : ''
                                }
                                 <span class="price-min" style="color: #cb333b;font-size: 24px;font-family: VolteB; margin-right: 10px;">
                                    ${"$" + price_min}                                 
                                </span>   
                                ${ price_max !== '0.00'  ?
                                  `<span class="price price--compare" style="font-size: 20px !important;">${"$" + price_max}</span>
                                   <div class="price-off-flag" style="padding: 4px 6px !important;">${discountPerc}% Off</div>` : ''
                                }
                                ` 
                              :
                           
                              `<span class="discount-price">
                                  ${"$" + discountPrice}
                              </span>                     
                                <span class="price" style="margin-left:0; color: #1e2d7d">
                                ${isOnSale ? `$${productPrice}` : `$${priceMinVariants}`}
                              </span>`
  
                              }
                            </div>
                            ${ discountOffNum > 0 && !isOnSale ?
                              `<div class="price-off-flag" style="padding: 4px 6px !important;">
                                ${discountOffNum}% Off
                              </div>` : ''
                            }                
                          
                      </div>` : ''
                     }
                     ${ multiFlag ?
                      	` <p class="product-promo__badge__text__multi"  style="padding: 0.3em 12px 0;font-size: 15px;">
                              <span>${ promo }</span>    
                              <span><strong>${ promoTag[1] }</strong></span>     
                         </p>`
                      	: `` 
                      } 
                    <p class="in-stock-flag">
                      ${ isInStock ? 'In-stock' : 'Out of stock' }
                    </p>                     
                </div>

             ${ !hidePrice ? 
                `<a style="${!isInStock ? 'display: none;': ''}"  href="${addToCartLink}" data-href="${productLink}" data-variant-id="${productVariantID}" class="product-item__action-button button button--primary ${hasMultipleVariants ? 'multiple-vari' : ''}">Add to cart</a>` 
                : '<a href="https://wellwise-dev-apim.azure-api.net/account/login?returnUrl='+full_url+'" class="login-to-price button button--primary" style="position: absolute;bottom: 25px;max-width: calc(100% - 40px);left: 50%;transform: translate(-50%);"> '+login_button_label+'</a>'   
               }
            </div>`;
          }
          
        }
		$regionBody.html(productsHtml);
		$regionBody.slick({
          rows: 1,
          slidesToScroll: 4,
          slidesToShow: 4,
          dots: false,
          arrows: false,
          infinite: true,
		  swipe: true,
          customPaging: function(slider, i) {
            return '<span class="dot"></span>';
          },
          speed: 300,
          responsive: [
			{
              breakpoint: 1450,
              settings: {
                slidesToScroll: 3,
                slidesToShow: 3
              }
            },
			{
              breakpoint: 1250,
              settings: {
                slidesToScroll: 2,
                slidesToShow: 2
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToScroll: 1,
                slidesToShow: 1
              }
            }
          ]
        });
        // setTimeout(function() {
        //   window.pwr = window.pwr || function () {
        //     (pwr.q = pwr.q || []).push(arguments);          
        //   };
         
        //   pwr('render', data.products.map(function(product){
           
        //     return {
        //       api_key: '82e7f73c-8992-40db-b68d-3b3961775487',
        //       locale: "en_CA",
        //       ENABLE_CLIENT_SIDE_STRUCTURED_DATA: false,
        //       merchant_group_id: '752464401',
        //       merchant_id: '1351473763',
        //       page_id: String(product.id),
        //       components: {
        //         CategorySnippet: 'snippet-' + String(product.id)
        //       }
        //     }
        //   }));
        // },1000);
      });
  });

  $(document).ready(function () {
  	$(".select-region-tabs > div:first-child").trigger("click");
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fitness-category-faq"]) return;
  try {
    
	$(document).on('click', '.faq-module .faq-item__header', function(e) {
      e.preventDefault(); 
      const $parentEl = $(this).parents('.faq-item');
	  $parentEl.toggleClass('active');

      $parentEl.find('.faq-item__body').slideToggle();
    });
	$(document).on('click', '.faq-module .load-more-faq', function(e) {
      e.preventDefault(); 

		$(this).slideToggle();
		$('.faq-item.load-more-hidden').slideToggle();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["health-category-faq"]) return;
  try {
    
	$(document).on('click', '.faq-module .faq-item__header', function(e) {
      e.preventDefault(); 
      const $parentEl = $(this).parents('.faq-item');
	  $parentEl.toggleClass('active');

      $parentEl.find('.faq-item__body').slideToggle();
    });
	$(document).on('click', '.faq-module .load-more-faq', function(e) {
      e.preventDefault(); 

		$(this).slideToggle();
		$('.faq-item.load-more-hidden').slideToggle();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-featured-collection"] && !Shopify.designMode) return;
  try {
    
	const $regionBody = $(".select-region-tab-body");
	const maxCount = parseInt($regionBody.attr('data-max-count'));
	
	$regionBody.on('breakpoint init', function(event, slick) {
		let html = '<ul class="slick-dots custom-dots" style="display: block;">';
	    const dotsLength = Math.ceil(slick.slideCount / slick.options.slidesToShow);
	    const $dots = slick.$dots;

	    if(dotsLength > 1)
	        html += '<li class="not-slick arrow-prev"><span></span></li>';
	    for(var i = 0; i < dotsLength; i++) {
	        html += '<li ' + (i == 0 ? 'class="slick-active"' : '' ) + '><span class="dot"></span></li>';
	    }
	    if(dotsLength > 1)
	        html += '<li class="not-slick arrow-next"><span></span></li>';

	    html += '</ul>';
	    if(dotsLength > 1)
	        $(slick.$list).append(html);
		
		matchHeights('.select-region-tab-body .ptitle', true);
	});

	$(document).on("click", ".select-region-tab-body .product-item__action-button", function (e) {
		e.preventDefault();
		const productVariantID = $(this).attr('data-variant-id');

		const cartData = {
          "bsub-recur": "",
          form_type: "product",
          id: productVariantID,
          "product-template-6704265068717-1": "Extra Small",
          "product-template-6704265068717-2": "10 Count",
          quantity: "1",
          utf8: "✓"
		};

        fetch("/cart/add.js", {
          "headers": {
            "accept": "*/*",
            "content-type": "application/json",
            "sec-fetch-mode": "cors",
            "sec-fetch-site": "same-origin",
            "x-requested-with": "XMLHttpRequest"
          },
		  "body": JSON.stringify(cartData),
          "method": "POST",
          "mode": "cors",
        }).then(res => res.json()).then((res) => {
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                  quantity: 1
              }
          }));
        });
	});

    $(document).on("click", ".select-region-tabs > div", function (e) {
      e.preventDefault();
	
	  if($(this).hasClass('active')) return false;
	  if($regionBody.hasClass('slick-initialized')) {
		$regionBody.slick('unslick');
	  }

      if ($(this).hasClass("active")) return false;
	  let productsHtml = '';

      const target = $(this).text().trim().toLowerCase();
      const collection = $(this).attr("data-collection");
	  $('.featured-collection-headline').addClass("display-none");
	  $("#" + collection + "-header").removeClass("display-none");
      $(".select-region-tabs > div.active").removeClass("active");
      $(this).addClass("active");

      $.ajax({
        url: "/collections/" + collection + "/products.json",
        type: "GET",
      }).done(function (data) {
        let productsHtml = "";
        let productsLength = data.products.length;

        if (productsLength > maxCount) {
          productsLength = maxCount;
        }

        for (var i = 0; i < productsLength; i++) {
          const product = data.products[i];
          const discountPrice = product.variants[0].price;
          const productPrice = product.variants[0].compare_at_price || discountPrice;
          const productLink = "/collections/" + collection + "/products/" + product.handle;
          const addToCartLink = "/cart/add?id=" + product.variants[0].id + "&quantity=1";
		  const productVariantID = product.variants[0].id;
          let discountOffNum = Math.round((1 - (discountPrice / productPrice)) * 100);
          let productImage;
          const isFreeShipping = productPrice > 25;
		  const hasMultipleVariants = product.variants.length > 1;
		  const isInStock = product.variants[0].available;
		  let pcPointLabel = `Get ${calculateBasePco(discountPrice)} base points*`;

		  if(typeof window.PCOPoints[productVariantID] !== 'undefined') {
			const pco = window.PCOPoints[productVariantID];

            if(pco.IsPromoTypeFixed) {
                pcPointLabel = `Get ${window.PCOPoints[productVariantID].PCOAmount} bonus points* and ${calculateBasePco(discountPrice)} base points*`;
            } else {
                pcPointLabel = `Get ${window.PCOPoints[productVariantID].PCOAmount}x the points* and ${calculateBasePco(discountPrice)} base points* when purchasing this participating product`;
            }
		  }

          if (product.images.length > 0 && product.images[0].src != null) {
            productImage = product.images[0].src;
          }
		  if(productImage) {
			productImage = productImage.replace('.png', '_200x.png');
		  }

          if (product) {
            productsHtml += `<div class="collections-product-item ${ productPrice != discountPrice ? "has-discount" : ""}">
                <div>
                    <div class="pc-opt-flag">
                        ${pcPointLabel}
                    </div>
                  ${ isFreeShipping ?
                    `<div class="free-shipping-flag">
                        Free Shipping
                    </div>` : ''
                  }
                    <a href="${productLink}">
                      <div class="img-container"> 
                        <img data-src="${ productImage }" class="lazyload" alt="" /> 
                      </div>

                      <span class="heading ptitle">
                        ${product.title}
                      </span>
                    </a>
                    <div class="ww-product-item__price">
                      <div class="price-container">
                        <span class="visually-hidden"> Sale price </span>
                        <span class="discount-price">
                            ${"$" + discountPrice}
                        </span>
                        <span class="price">
                            ${"$" + productPrice}
                        </span>
                      </div>

                      ${ discountOffNum > 0 ?
                        `<div class="price-off-flag">
                          ${discountOffNum}% Off
                        </div>` : ''
                      }
                    </div>
                    <p class="in-stock-flag">
                        In-stock
                    </p>
                </div>

                <a href="${addToCartLink}" data-variant-id="${productVariantID}" class="product-item__action-button button button--primary">Add to cart</a>
            </div>`;
          }
        }

		$regionBody.html(productsHtml);
		$regionBody.slick({
          rows: target ==  $('.select-region-tabs > div:last-child').text().trim().toLowerCase() ? 2 : 1,
          slidesToScroll: 4,
          slidesToShow: 4,
          dots: false,
          arrows: false,
          infinite: true,
		  swipe: false,
          customPaging: function(slider, i) {
            return '<span class="dot"></span>';
          },
          speed: 300,
          responsive: [
			{
              breakpoint: 1450,
              settings: {
                slidesToScroll: 3,
                slidesToShow: 3
              }
            },
			{
              breakpoint: 1250,
              settings: {
                slidesToScroll: 2,
                slidesToShow: 2
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToScroll: 1,
                slidesToShow: 1,
				rows: 1
              }
            }
          ]
        });
      });
  });

  $(document).ready(function () {
  	$(".select-region-tabs > div:first-child").trigger("click");
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-category-faq"]) return;
  try {
    
	$(document).on('click', '.faq-module .faq-item__header', function(e) {
      e.preventDefault(); 
      const $parentEl = $(this).parents('.faq-item');
	  $parentEl.toggleClass('active');

      $parentEl.find('.faq-item__body').slideToggle();
    });
	$(document).on('click', '.faq-module .load-more-faq', function(e) {
      e.preventDefault(); 

		$(this).slideToggle();
		$('.faq-item.load-more-hidden').slideToggle();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-services-contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const form = document.getElementById('homeServicesContactForm');
    const submitBtn = document.getElementById('submitBtn');
    const submitText = document.getElementById('submitText');
    const successMsg = document.getElementById('form-success');
    const errorMsg = document.getElementById('form-error');
    const errorMsgText = document.getElementById('error-message');

    // Required fields
    const requiredFields = ['firstName', 'lastName', 'email', 'phone', 'address', 'inquiryType'];

    // Check if at least one service is selected
    function hasServiceSelected() {
      const checkboxes = form.querySelectorAll('input[name="contact[services][]"]');
      return Array.from(checkboxes).some((cb) => cb.checked);
    }

    // Validate form
    function validateForm() {
      const allFieldsFilled = requiredFields.every((fieldId) => {
        const field = document.getElementById(fieldId);
        return field && field.value.trim() !== '';
      });

      const serviceSelected = hasServiceSelected();
      submitBtn.disabled = !(allFieldsFilled && serviceSelected);
    }

    // Add validation listeners
    requiredFields.forEach((fieldId) => {
      const field = document.getElementById(fieldId);
      if (field) {
        field.addEventListener('input', validateForm);
        field.addEventListener('change', validateForm);
      }
    });

    // Add listeners to checkboxes
    const checkboxes = form.querySelectorAll('input[name="contact[services][]"]');
    checkboxes.forEach((cb) => {
      cb.addEventListener('change', validateForm);
    });

    // Handle form submission
    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      submitBtn.disabled = true;
      submitText.textContent = 'Submitting...';
      successMsg.style.display = 'none';
      errorMsg.style.display = 'none';

      const formData = new FormData(form);

      try {
        const response = await fetch('/contact', {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'application/json',
          },
        });

        if (response.ok || response.redirected) {
          successMsg.style.display = 'flex';
          form.reset();
          submitBtn.disabled = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          throw new Error('Submission failed');
        }
      } catch (error) {
        errorMsg.style.display = 'flex';
        errorMsgText.textContent = 'There was an error submitting the form. Please try again or contact us directly.';
        submitBtn.disabled = false;
      } finally {
        submitText.textContent = 'Submit Request';
      }
    });

    // Initial validation
    validateForm();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-services-contact-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    try {
      var f = document.createElement('iframe');

      var ifrmSrc =
        'https://forms.zohopublic.ca/wellwise/form/HomeServices/formperma/GvoDSa-PrUN1KDR8-1wwoFbn5Rt2OVm8J22MPo7kaBo?zf_rszfm=1';

      try {
        if (typeof ZFAdvLead != 'undefined' && typeof zfutm_zfAdvLead != 'undefined') {
          for (var prmIdx = 0; prmIdx < ZFAdvLead.utmPNameArr.length; prmIdx++) {
            var utmPm = ZFAdvLead.utmPNameArr[prmIdx];
            utmPm = ZFAdvLead.isSameDomian && ZFAdvLead.utmcustPNameArr.indexOf(utmPm) == -1 ? 'zf_' + utmPm : utmPm;
            var utmVal = zfutm_zfAdvLead.zfautm_gC_enc(ZFAdvLead.utmPNameArr[prmIdx]);
            if (typeof utmVal !== 'undefined') {
              if (utmVal != '') {
                if (ifrmSrc.indexOf('?') > 0) {
                  ifrmSrc = ifrmSrc + '&' + utmPm + '=' + utmVal;
                } else {
                  ifrmSrc = ifrmSrc + '?' + utmPm + '=' + utmVal;
                }
              }
            }
          }
        }
        if (typeof ZFLead !== 'undefined' && typeof zfutm_zfLead !== 'undefined') {
          for (var prmIdx = 0; prmIdx < ZFLead.utmPNameArr.length; prmIdx++) {
            var utmPm = ZFLead.utmPNameArr[prmIdx];
            var utmVal = zfutm_zfLead.zfutm_gC_enc(ZFLead.utmPNameArr[prmIdx]);
            if (typeof utmVal !== 'undefined') {
              if (utmVal != '') {
                if (ifrmSrc.indexOf('?') > 0) {
                  ifrmSrc = ifrmSrc + '&' + utmPm + '=' + utmVal;
                } else {
                  ifrmSrc = ifrmSrc + '?' + utmPm + '=' + utmVal;
                }
              }
            }
          }
        }
      } catch (e) {}

      f.src = ifrmSrc;
      f.style.border = 'none';
      f.style.height = '2682px';
      f.style.width = '90%';
      f.style.transition = 'all 0.5s ease';
      f.setAttribute('aria-label', 'Fill out the form below to contact Wellwise® Home Services');

      var d = document.getElementById('zf_div_GvoDSa-PrUN1KDR8-1wwoFbn5Rt2OVm8J22MPo7kaBo');
      d.appendChild(f);

      window.addEventListener(
        'message',
        function () {
          var evntData = event.data;
          if (evntData && evntData.constructor == String) {
            var zf_ifrm_data = evntData.split('|');
            if (zf_ifrm_data.length == 2 || zf_ifrm_data.length == 3) {
              var zf_perma = zf_ifrm_data[0];
              var zf_ifrm_ht_nw = parseInt(zf_ifrm_data[1], 10) + 15 + 'px';
              var iframe = document
                .getElementById('zf_div_GvoDSa-PrUN1KDR8-1wwoFbn5Rt2OVm8J22MPo7kaBo')
                .getElementsByTagName('iframe')[0];
              if (iframe.src.indexOf('formperma') > 0 && iframe.src.indexOf(zf_perma) > 0) {
                var prevIframeHeight = iframe.style.height;
                var zf_tout = false;
                if (zf_ifrm_data.length == 3) {
                  iframe.scrollIntoView();
                  zf_tout = true;
                }

                if (prevIframeHeight != zf_ifrm_ht_nw) {
                  if (zf_tout) {
                    setTimeout(function () {
                      iframe.style.height = zf_ifrm_ht_nw;
                    }, 500);
                  } else {
                    iframe.style.height = zf_ifrm_ht_nw;
                  }
                }
              }
            }
          }
        },
        false
      );
    } catch (e) {}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-services-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const faqButtons = document.querySelectorAll('.faq-question');

    faqButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const faqItem = this.closest('.faq-item');
        const answer = faqItem.querySelector('.faq-answer');
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        // Close all other FAQs (optional - remove this section for multi-open behavior)
        faqButtons.forEach((otherButton) => {
          if (otherButton !== this) {
            otherButton.setAttribute('aria-expanded', 'false');
            const otherAnswer = otherButton.closest('.faq-item').querySelector('.faq-answer');
            otherAnswer.setAttribute('hidden', '');
          }
        });

        // Toggle current FAQ
        this.setAttribute('aria-expanded', !isExpanded);
        if (isExpanded) {
          answer.setAttribute('hidden', '');
        } else {
          answer.removeAttribute('hidden');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-services-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Mobile Menu Functionality
    const mobileMenuBtn = document.getElementById('mobileMenuBtn');
    const mobileNav = document.getElementById('mobileNav');
    const menuIcon = document.getElementById('menuIcon');
    const closeIcon = document.getElementById('closeIcon');

    function toggleMobileMenu() {
      const isOpen = mobileNav.classList.contains('is-open');

      if (isOpen) {
        mobileNav.classList.remove('is-open');
        menuIcon.style.display = 'block';
        closeIcon.style.display = 'none';
        mobileMenuBtn.setAttribute('aria-expanded', 'false');
        mobileMenuBtn.setAttribute('aria-label', 'Open navigation menu');
      } else {
        mobileNav.classList.add('is-open');
        menuIcon.style.display = 'none';
        closeIcon.style.display = 'block';
        mobileMenuBtn.setAttribute('aria-expanded', 'true');
        mobileMenuBtn.setAttribute('aria-label', 'Close navigation menu');
      }
    }

    if (mobileMenuBtn && mobileNav) {
      mobileMenuBtn.addEventListener('click', toggleMobileMenu);

      // Close mobile menu when clicking outside
      document.addEventListener('click', function (event) {
        if (!mobileMenuBtn.contains(event.target) && !mobileNav.contains(event.target)) {
          if (mobileNav.classList.contains('is-open')) {
            toggleMobileMenu();
          }
        }
      });

      // Close mobile menu with Escape key
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && mobileNav.classList.contains('is-open')) {
          toggleMobileMenu();
          mobileMenuBtn.focus();
        }
      });

      // Close mobile menu when window is resized to desktop
      window.addEventListener('resize', function () {
        if (window.innerWidth >= 768 && mobileNav.classList.contains('is-open')) {
          toggleMobileMenu();
        }
      });
    }

    // Desktop Dropdown Keyboard Accessibility
    const dropdownTriggers = document.querySelectorAll('[data-dropdown-trigger]');

    dropdownTriggers.forEach(function (trigger) {
      const dropdown = trigger.closest('.services-nav-dropdown');
      const menu = dropdown.querySelector('.dropdown-menu');
      const menuItems = menu.querySelectorAll('.dropdown-item');
      let isOpen = false;

      function openDropdown() {
        isOpen = true;
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }

      function closeDropdown() {
        isOpen = false;
        dropdown.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }

      // Click to toggle
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        if (isOpen) {
          closeDropdown();
        } else {
          // Close other dropdowns
          document.querySelectorAll('.services-nav-dropdown.is-open').forEach(function (otherDropdown) {
            if (otherDropdown !== dropdown) {
              otherDropdown.classList.remove('is-open');
              const otherTrigger = otherDropdown.querySelector('[data-dropdown-trigger]');
              if (otherTrigger) {
                otherTrigger.setAttribute('aria-expanded', 'false');
              }
            }
          });
          openDropdown();
        }
      });

      // Keyboard navigation
      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          if (isOpen) {
            closeDropdown();
          } else {
            openDropdown();
            // Focus first menu item
            if (menuItems.length > 0) {
              menuItems[0].focus();
            }
          }
        } else if (event.key === 'ArrowDown') {
          event.preventDefault();
          openDropdown();
          if (menuItems.length > 0) {
            menuItems[0].focus();
          }
        } else if (event.key === 'Escape') {
          closeDropdown();
        }
      });

      // Arrow key navigation within menu
      menuItems.forEach(function (item, index) {
        item.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            const nextIndex = (index + 1) % menuItems.length;
            menuItems[nextIndex].focus();
          } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            const prevIndex = (index - 1 + menuItems.length) % menuItems.length;
            menuItems[prevIndex].focus();
          } else if (event.key === 'Escape') {
            event.preventDefault();
            closeDropdown();
            trigger.focus();
          } else if (event.key === 'Tab') {
            closeDropdown();
          }
        });
      });

      // Close dropdown when clicking outside
      document.addEventListener('click', function (event) {
        if (!dropdown.contains(event.target)) {
          closeDropdown();
        }
      });

      // Close dropdown on mouse leave (maintain hover behavior)
      dropdown.addEventListener('mouseleave', function () {
        if (isOpen) {
          closeDropdown();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["incontinence-category-faq"]) return;
  try {
    
	$(document).on('click', '.faq-module .faq-item__header', function(e) {
      e.preventDefault(); 
      const $parentEl = $(this).parents('.faq-item');
	  $parentEl.toggleClass('active');

      $parentEl.find('.faq-item__body').slideToggle();
    });
	$(document).on('click', '.faq-module .load-more-faq', function(e) {
      e.preventDefault(); 

		$(this).slideToggle();
		$('.faq-item.load-more-hidden').slideToggle();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["light-therapy-category-faq"]) return;
  try {
    
	$(document).on('click', '.faq-module .faq-item__header', function(e) {
      e.preventDefault(); 
      const $parentEl = $(this).parents('.faq-item');
	  $parentEl.toggleClass('active');

      $parentEl.find('.faq-item__body').slideToggle();
    });
	$(document).on('click', '.faq-module .load-more-faq', function(e) {
      e.preventDefault(); 

		$(this).slideToggle();
		$('.faq-item.load-more-hidden').slideToggle();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ostomy-category-faq"]) return;
  try {
    
	$(document).on('click', '.faq-module .faq-item__header', function(e) {
      e.preventDefault(); 
      const $parentEl = $(this).parents('.faq-item');
	  $parentEl.toggleClass('active');

      $parentEl.find('.faq-item__body').slideToggle();
    });
	$(document).on('click', '.faq-module .load-more-faq', function(e) {
      e.preventDefault(); 

		$(this).slideToggle();
		$('.faq-item.load-more-hidden').slideToggle();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-funding-template"]) return;
  try {
    
    $(document).on('click', '.select-region-tabs > div', function(e) {
      e.preventDefault();
      if($(this).hasClass('active')) return false;
      
      const target = $(this).text().trim().toLowerCase();
      console.log('.select-region-tabs_body [data-type="' + target + '"]');
      $('.select-region-tabs > div.active').removeClass('active');
      $(this).addClass('active');
      
      $('.select-region-tabs_body > div').slideUp();
      $('.select-region-tabs_body [data-type="' + target + '"]').slideToggle();
    });
  
  	$(document).on('click', '.select-region-tabs_body .item-header', function(e) {
      e.preventDefault(); 
      
      //$('.select-region-tabs_body .item-header').removeClass('active');
      $(this).toggleClass('active');
      
      //$('.select-region-tabs_body .item-body').slideUp();
      $(this).next().slideToggle();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-services-template"]) return;
  try {
    
  $(document).ready(function() {
	var url = window.location.href.toLowerCase();

    if(url.indexOf('dl=cpap') > -1) {
      $('.service-deeplink[data-target=".rest-easy"]').trigger('click');
    }
    if(url.indexOf('dl=braces') > -1) {
      $('.service-deeplink[data-target=".fitting-sect"]').trigger('click');
    }
    if(url.indexOf('dl=home') > -1) {
      $('.service-deeplink[data-target=".home-sect"]').trigger('click');
    }
    if(url.indexOf('dl=compression') > -1) {
      $('.service-deeplink[data-target=".comp-serv-sect"]').trigger('click');
    }
    if(url.indexOf('dl=rentals') > -1) {
      $('.service-deeplink[data-target=".recovery-sect"]').trigger('click');
    }
    if(url.indexOf('dl=shipping') > -1) {
      $('.service-deeplink[data-target=".order-terms-sect"]').trigger('click');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pain-category-faq"]) return;
  try {
    
	$(document).on('click', '.faq-module .faq-item__header', function(e) {
      e.preventDefault(); 
      const $parentEl = $(this).parents('.faq-item');
	  $parentEl.toggleClass('active');

      $parentEl.find('.faq-item__body').slideToggle();
    });
	$(document).on('click', '.faq-module .load-more-faq', function(e) {
      e.preventDefault(); 

		$(this).slideToggle();
		$('.faq-item.load-more-hidden').slideToggle();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rollators-walkers-category-faq"]) return;
  try {
    
	$(document).on('click', '.faq-module .faq-item__header', function(e) {
      e.preventDefault(); 
      const $parentEl = $(this).parents('.faq-item');
	  $parentEl.toggleClass('active');

      $parentEl.find('.faq-item__body').slideToggle();
    });
	$(document).on('click', '.faq-module .load-more-faq', function(e) {
      e.preventDefault(); 

		$(this).slideToggle();
		$('.faq-item.load-more-hidden').slideToggle();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scooters-pc-category-faq"]) return;
  try {
    
	$(document).on('click', '.faq-module .faq-item__header', function(e) {
      e.preventDefault(); 
      const $parentEl = $(this).parents('.faq-item');
	  $parentEl.toggleClass('active');

      $parentEl.find('.faq-item__body').slideToggle();
    });
	$(document).on('click', '.faq-module .load-more-faq', function(e) {
      e.preventDefault(); 

		$(this).slideToggle();
		$('.faq-item.load-more-hidden').slideToggle();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sleep-aids-category-faq"]) return;
  try {
    
	$(document).on('click', '.faq-module .faq-item__header', function(e) {
      e.preventDefault(); 
      const $parentEl = $(this).parents('.faq-item');
	  $parentEl.toggleClass('active');

      $parentEl.find('.faq-item__body').slideToggle();
    });
	$(document).on('click', '.faq-module .load-more-faq', function(e) {
      e.preventDefault(); 

		$(this).slideToggle();
		$('.faq-item.load-more-hidden').slideToggle();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellness-category-faq"]) return;
  try {
    
	$(document).on('click', '.faq-module .faq-item__header', function(e) {
      e.preventDefault(); 
      const $parentEl = $(this).parents('.faq-item');
	  $parentEl.toggleClass('active');

      $parentEl.find('.faq-item__body').slideToggle();
    });
	$(document).on('click', '.faq-module .load-more-faq', function(e) {
      e.preventDefault(); 

		$(this).slideToggle();
		$('.faq-item.load-more-hidden').slideToggle();
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellwiseday-featured-collection"] && !Shopify.designMode) return;
  try {
    
	const $regionBody = $(".select-region-tab-body");
	const maxCount = parseInt($regionBody.attr('data-max-count'));
	
	$regionBody.on('breakpoint init', function(event, slick) {
		let html = '<ul class="slick-dots custom-dots" style="display: block;">';
	    const dotsLength = Math.ceil(slick.slideCount / slick.options.slidesToShow);
	    const $dots = slick.$dots;

	    if(dotsLength > 1)
	        html += '<li class="not-slick arrow-prev"><span></span></li>';
	    for(var i = 0; i < dotsLength; i++) {
	        html += '<li ' + (i == 0 ? 'class="slick-active"' : '' ) + '><span class="dot"></span></li>';
	    }
	    if(dotsLength > 1)
	        html += '<li class="not-slick arrow-next"><span></span></li>';

	    html += '</ul>';
	    if(dotsLength > 1)
	        $(slick.$list).append(html);
		
		matchHeights('.select-region-tab-body .ptitle', true);
	});

	$(document).on("click", ".select-region-tab-body .product-item__action-button", function (e) {
		e.preventDefault();
		const productVariantID = $(this).attr('data-variant-id');

		const cartData = {
          "bsub-recur": "",
          form_type: "product",
          id: productVariantID,
          "product-template-6704265068717-1": "Extra Small",
          "product-template-6704265068717-2": "10 Count",
          quantity: "1",
          utf8: "✓"
		};

        fetch("/cart/add.js", {
          "headers": {
            "accept": "*/*",
            "content-type": "application/json",
            "sec-fetch-mode": "cors",
            "sec-fetch-site": "same-origin",
            "x-requested-with": "XMLHttpRequest"
          },
		  "body": JSON.stringify(cartData),
          "method": "POST",
          "mode": "cors",
        }).then(res => res.json()).then((res) => {
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                  quantity: 1
              }
          }));
        });
	});

    $(document).on("click", ".select-region-tabs > div", function (e) {
      e.preventDefault();
	
	  if($(this).hasClass('active')) return false;
	  if($regionBody.hasClass('slick-initialized')) {
		$regionBody.slick('unslick');
	  }

      if ($(this).hasClass("active")) return false;
	  let productsHtml = '';

      const target = $(this).text().trim().toLowerCase();
      const collection = $(this).attr("data-collection");
	  $('.featured-collection-headline').addClass("display-none");
	  $("#" + collection + "-header").removeClass("display-none");
      $(".select-region-tabs > div.active").removeClass("active");
      $(this).addClass("active");

      $.ajax({
        url: "/collections/" + collection + "/products.json",
        type: "GET",
      }).done(function (data) {
        let productsHtml = "";
        let productsLength = data.products.length;

        if (productsLength > maxCount) {
          productsLength = maxCount;
        }

        for (var i = 0; i < productsLength; i++) {
          const product = data.products[i];
          const discountPrice = product.variants[0].price;
          const productPrice = product.variants[0].compare_at_price || discountPrice;
          const productLink = "/collections/" + collection + "/products/" + product.handle;
          const addToCartLink = "/cart/add?id=" + product.variants[0].id + "&quantity=1";
		  const productVariantID = product.variants[0].id;
          let discountOffNum = Math.round((1 - (discountPrice / productPrice)) * 100);
          let productImage;
          const isFreeShipping = productPrice > 25;
		  const hasMultipleVariants = product.variants.length > 1;
		  const isInStock = product.variants[0].available;
		  let pcPointLabel = `Get ${calculateBasePco(discountPrice)} base points*`;

		  if(typeof window.PCOPoints[productVariantID] !== 'undefined') {
			const pco = window.PCOPoints[productVariantID];

			if(pco.IsPromoTypeFixed) {
                pcPointLabel = `Get ${window.PCOPoints[productVariantID].PCOAmount} bonus points* and ${calculateBasePco(discountPrice)} base points*`;
            } else {
                pcPointLabel = `Get ${window.PCOPoints[productVariantID].PCOAmount}x the points* and ${calculateBasePco(discountPrice)} base points* when purchasing this participating product`;
            }
		  }

          if (product.images.length > 0 && product.images[0].src != null) {
            productImage = product.images[0].src;
          }
		  if(productImage) {
			productImage = productImage.replace('.png', '_200x.png');
		  }

          if (product) {
            productsHtml += `<div class="collections-product-item ${ productPrice != discountPrice ? "has-discount" : ""}">
                <div>
                    <div class="pc-opt-flag">
                        ${pcPointLabel}
                    </div>
                  ${ isFreeShipping ?
                    `<div class="free-shipping-flag">
                        Free Shipping
                    </div>` : ''
                  }
                    <a href="${productLink}">
                      <div class="img-container"> 
                        <img data-src="${ productImage }" class="lazyload" alt="" /> 
                      </div>

                      <span class="heading ptitle">
                        ${product.title}
                      </span>
                    </a>
                    <div class="ww-product-item__price">
                      <div class="price-container">
                        <span class="visually-hidden"> Sale price </span>
                        <span class="discount-price">
                            ${"$" + discountPrice}
                        </span>
                        <span class="price">
                            ${"$" + productPrice}
                        </span>
                      </div>

                      ${ discountOffNum > 0 ?
                        `<div class="price-off-flag">
                          ${discountOffNum}% Off
                        </div>` : ''
                      }
                    </div>
                    <p class="in-stock-flag">
                        In-stock
                    </p>
                </div>

                <a href="${addToCartLink}" data-variant-id="${productVariantID}" class="product-item__action-button button button--primary">Add to cart</a>
            </div>`;
          }
        }

		$regionBody.html(productsHtml);
		$regionBody.slick({
          rows: target ==  $('.select-region-tabs > div:last-child').text().trim().toLowerCase() ? 2 : 1,
          slidesToScroll: 4,
          slidesToShow: 4,
          dots: false,
          arrows: false,
          infinite: true,
		  swipe: false,
          customPaging: function(slider, i) {
            return '<span class="dot"></span>';
          },
          speed: 300,
          responsive: [
			{
              breakpoint: 1450,
              settings: {
                slidesToScroll: 3,
                slidesToShow: 3
              }
            },
			{
              breakpoint: 1250,
              settings: {
                slidesToScroll: 2,
                slidesToShow: 2
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToScroll: 1,
                slidesToShow: 1,
				rows: 1
              }
            }
          ]
        });
      });
  });

  $(document).ready(function () {
  	$(".select-region-tabs > div:first-child").trigger("click");
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wheelc-transportc-category-faq"]) return;
  try {
    
	$(document).on('click', '.faq-module .faq-item__header', function(e) {
      e.preventDefault(); 
      const $parentEl = $(this).parents('.faq-item');
	  $parentEl.toggleClass('active');

      $parentEl.find('.faq-item__body').slideToggle();
    });
	$(document).on('click', '.faq-module .load-more-faq', function(e) {
      e.preventDefault(); 

		$(this).slideToggle();
		$('.faq-item.load-more-hidden').slideToggle();
	});

  } catch(e) { console.error(e); }
})();
})();
